<mat-toolbar color="primary">
  <mat-toolbar-row>
    <a [routerLink]="'/account'"><img  src="/assets/img/fes_logo3.svg" class="logo-image"></a>
    <span class="spacer"></span>
    <div *ngIf="horizontalMenu">
      <span *ngFor="let item of menuList">
        <!-- Handle branch node buttons here -->
        <span *ngIf="item.children && item.children.length > 0 && this.utilService.checkRoleAccess(item)">
          <button mat-button [matMenuTriggerFor]="menu.childMenu" [ngClass]="{'active' : (currentPath==item.link), 'tab': true}">
            {{item.label}}
            <mat-icon>expand_more</mat-icon>
          </button>
<!--          <a mat-button [routerLink]="'/dashboard'" [ngClass]="{'active' : (currentPath=='/dashboard'  ), 'tab': true}">{{item.label}}</a>-->
          <app-menu-item #menu [items]="item.children" [currentPath]="currentPath"></app-menu-item>
        </span>
            <!-- Leaf node buttons here -->
        <span *ngIf="(!item.children || item.children.length === 0) && this.utilService.checkRoleAccess(item)">
          <button mat-button [routerLink]="item.link" [ngClass]="{'active' : (currentPath==item.link), 'tab': true}">
            {{item.label}}
          </button>
        </span>
      </span>
<!--      <a mat-button [routerLink]="'/dashboard'" [ngClass]="{'active' : (currentPath=='/dashboard'  ), 'tab': true}">Matrix Deals</a>-->
<!--      <a mat-button [routerLink]="'/custom-deals'" [ngClass]="{'active' : (currentPath=='/custom-deals'  ), 'tab': true}">Custom Deals </a>-->
<!--      <a mat-button [routerLink]="'/preferred-pricing'" [ngClass]="{'active' : (currentPath=='/preferred-pricing'  ), 'tab': true}">Preferred Pricing </a>-->
<!--          <a mat-button [routerLink]="'/account'" [ngClass]="{'active' : (currentPath=='/account'  ), 'tab': true}">Account </a>-->
    </div>
<!--    <div *ngIf="!horizontalMenu">-->
<!--    <button mat-icon-button [matMenuTriggerFor]="menu">-->
<!--      <mat-icon  >menu</mat-icon>-->
<!--    </button>-->
<!--     <mat-menu #menu="matMenu">-->
<!--       <button mat-menu-item><a mat-button [routerLink]="'/dashboard'" [ngClass]="{'active' : (currentPath=='/dashboard'  ), 'tab': true}">Dashbaord</a></button>-->
<!--       <button mat-menu-item><a mat-button [routerLink]="'/custom-deals'" [ngClass]="{'active' : (currentPath=='/custom-deals'  ), 'tab': true}">Custom Deals </a></button>-->
<!--       <button mat-menu-item><a mat-button [routerLink]="'/quick-quotes'" [ngClass]="{'active' : (currentPath=='/quick-quotes'  ), 'tab': true}">Quick Quotes </a></button>-->
<!--       <button mat-menu-item><a mat-button [routerLink]="'/account'" [ngClass]="{'active' : (currentPath=='/account'  ), 'tab': true}">Account </a></button>-->
<!--    </mat-menu>-->
<!--    </div>-->
  </mat-toolbar-row>
</mat-toolbar>
